import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// Import Google Fonts - Inter (modern, clean, free font)
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
// Custom Bootstrap variable overrides (must be imported after bootstrap.css)
import './assets/css/bootstrap-override.css'
import './assets/css/custom.css'
import api from './plugins/axios'
import './registerServiceWorker'
import {LoadingPlugin} from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/css/index.css';
import { createPinia } from 'pinia'



const app = createApp(App)
app.config.globalProperties.$api = api
app.use(router)
app.use(LoadingPlugin)
app.use(createPinia())
app.mount('#app')
